import { ProblemDefinition } from './types';

const schemaDDL = `
CREATE TABLE departments (id INTEGER PRIMARY KEY, name TEXT NOT NULL, budget REAL);
CREATE TABLE employees (id INTEGER PRIMARY KEY, first_name TEXT NOT NULL, last_name TEXT NOT NULL, dept_id INTEGER, salary REAL, hire_date TEXT, manager_id INTEGER, FOREIGN KEY(dept_id) REFERENCES departments(id), FOREIGN KEY(manager_id) REFERENCES employees(id));
`;

const seedDML = `
INSERT INTO departments (id, name, budget) VALUES
  (1, 'Engineering', 500000),
  (2, 'Sales', 300000),
  (3, 'Marketing', 200000),
  (4, 'HR', 150000);

INSERT INTO employees (id, first_name, last_name, dept_id, salary, hire_date, manager_id) VALUES
  (1, 'Alice', 'Johnson', 1, 95000, '2020-03-15', NULL),
  (2, 'Bob', 'Smith', 1, 88000, '2021-06-01', 1),
  (3, 'Carol', 'Williams', 2, 72000, '2019-11-20', NULL),
  (4, 'David', 'Brown', 2, 65000, '2022-01-10', 3),
  (5, 'Eva', 'Davis', 3, 78000, '2020-07-22', NULL),
  (6, 'Frank', 'Miller', 1, 92000, '2018-09-05', 1),
  (7, 'Grace', 'Wilson', NULL, 60000, '2023-02-14', NULL),
  (8, 'Henry', 'Taylor', 3, 70000, '2021-04-30', 5),
  (9, 'Ivy', 'Anderson', 4, 67000, '2022-08-18', NULL),
  (10, 'Jack', 'Thomas', NULL, 55000, '2023-05-01', NULL);
`;

export const whereProblems: ProblemDefinition[] = [
 {
  id: 'where-easy-1',
  title: 'High Salary Employees',
  statement: `Write a query to find the **first name**, **last name**, and **salary** of all employees who earn more than **80,000**.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name', 'salary'],
   values: [
    ['Alice', 'Johnson', 95000],
    ['Bob', 'Smith', 88000],
    ['Frank', 'Miller', 92000],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'easy',
  topicTags: ['where'],
  hints: ['Use WHERE salary > 80000 to filter rows.'],
 },
 {
  id: 'where-easy-2',
  title: 'Engineering Department',
  statement: `Write a query to find the **first name** and **last name** of all employees in the Engineering department (dept_id = 1).`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name'],
   values: [
    ['Alice', 'Johnson'],
    ['Bob', 'Smith'],
    ['Frank', 'Miller'],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'easy',
  topicTags: ['where'],
  hints: ['Use WHERE dept_id = 1 to filter by department.'],
 },
 {
  id: 'where-medium-1',
  title: 'Salary Range',
  statement: `Write a query to find the **first name**, **last name**, and **salary** of employees whose salary is between **65,000 and 80,000** (inclusive).`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name', 'salary'],
   values: [
    ['Carol', 'Williams', 72000],
    ['David', 'Brown', 65000],
    ['Eva', 'Davis', 78000],
    ['Henry', 'Taylor', 70000],
    ['Ivy', 'Anderson', 67000],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'medium',
  topicTags: ['where'],
  hints: [
   'Use BETWEEN to check if a value falls within a range.',
   'Example: WHERE salary BETWEEN 65000 AND 80000',
  ],
 },
 {
  id: 'where-medium-2',
  title: 'Name Pattern Matching',
  statement: `Write a query to find the **first name** and **last name** of all employees whose last name starts with the letter **"T"**.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name'],
   values: [
    ['Henry', 'Taylor'],
    ['Jack', 'Thomas'],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'medium',
  topicTags: ['where'],
  hints: [
   'Use the LIKE operator for pattern matching.',
   "Example: WHERE last_name LIKE 'T%' matches names starting with T.",
  ],
 },
];
